import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function BoxDuoFeaturedServices({ setIsdata }) {
  const [featuredService, setFeaturedService] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getFeaturedService();
  }, []);

  const getFeaturedService = async () => {
    setLoading(true);
    const response = await SendPostRequest("services/featured_services");
    if (response?.data.length < 5 && sitedata?.site_type === "hospitals") {
      setIsdata(true);
    }
    setFeaturedService(response?.data);
    setLoading(false);
  };

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    // animateIn: "slideInRight",
    // animateOut: "slideOutLeft",
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        featuredService?.length > 0 && (
          <section
            id="services-section"
            className="services-section semi-dark pt-4 pb-0"
          >
            <div className="container">
              <div className="row">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                         {sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <OwlCarousel className="service-main-wrapper" {...options}>
                    {featuredService?.map((service, index) => (
                      <div className="item animated fadeInLeft visible" key={index}>
                        <div className="feature-box-wrap f-box-style-6 relative duo-box-home-height">
                          <div className="feature-box-details h-100">
                            <div className="feature-img">
                              <img className="img-fluid" src={service?.service_image_url}
                                style={{ height: "auto" }}
                                width="425" alt="feature img" />
                            </div>
                            <div className="feature-content mt-4 mb-2">
                              <div className="feature-title relative margin-bottom-5">
                                <h5>{service?.service_title}</h5>
                              </div>
                              <p className="mb-0">

                                <div
                                  className="service-desc mb-4"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      limitParagraphByCharLimit(service?.clean_service_description, 75) +
                                      (service?.clean_service_description?.length > 75 ? "..." : ""),
                                  }}

                                />
                              </p>
                            </div>
                            <div className="button">
                              <Link
                                className="btn-link"
                                    to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                    .replaceAll(" ", "-")
                                    .replaceAll("/", "-")}`}
                              >Read More</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </section>
        )
      )}
    </>
  );
}

export default BoxDuoFeaturedServices;
